/**
 * ログインフォームのバリデーション
 */

import * as validate from '~/utility/validation/validation';

interface Login {
  email: string;
  password: string;
}

export default (body: any): any => new Promise((resolve, reject) => {
  const {
    email,
    password
  } = body.session as Login

  // 検査対象のフィールドのエラーを空配列で定義する
  const validationErrors: any = {
    email: [],
    password: [],
  };

  // メールアドレス
  validate.required(email) && validationErrors.email.push(validate.required(email));
  validate.email(email) && validationErrors.email.push(validate.email(email));

  // パスワード
  validate.required(password) && validationErrors.password.push(validate.required(password));

  if (Object.keys(validationErrors).every(key => validationErrors[key].length === 0)) {
    resolve(body);
  } else {
    reject(validationErrors);
  };
}
);
